import { IsNotEmpty, IsUUID, IsOptional, IsBoolean } from 'class-validator';

export class MarkReadDto {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsBoolean()
  @IsOptional()
  removeFromList?: boolean;
}
